<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['metro:sys:add']" type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd" >新增</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" :data="metroList"  style="width: 100%" border>
      <el-table-column label="轨道系统logo" align="center" prop="metroLogo" min-width="120">
        <template slot-scope="scope">
          <image-preview :src="scope.row.metroLogo" :width="90" :height="90" />
        </template>
      </el-table-column>
      <el-table-column label="轨道交通系统编码" align="center" prop="metroCode" min-width="150"/>
      <el-table-column label="轨道交通系统名称" align="center" prop="metroName" min-width="150" >
        <template slot-scope="scope">
          <a v-if="$auth.hasPermi('metro:line:list')" class="link-type" style="cursor:pointer" @click="handleViewData(scope.row)">{{ scope.row.metroName }}</a>
          <span v-else>{{ scope.row.metroName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="运营线路数量" align="center" prop="operateLineCount" min-width="120"/>
      <el-table-column label="运营长度(km)" align="center" prop="totalLength" min-width="120"/>
      <el-table-column label="运营站点数量" align="center" prop="operateStationCount" min-width="120"/>
      <el-table-column label="备注" align="center" prop="remark" min-width="180"/>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="200">
        <template slot-scope="scope">
          <el-button v-hasPermi="['metro:sys:edit']" size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)" >修改</el-button>
          <el-button v-hasPermi="['metro:line:list']" size="mini" type="text" icon="el-icon-s-operation" @click="handleToLine(scope.row)" >线路</el-button>
          <el-button v-hasPermi="['metro:sys:remove']" size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)" >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加或修改轨道交通系统对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" :close-on-click-modal="false"  append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="轨道交通系统编码" prop="metroCode">
              <el-input v-model="form.metroCode" placeholder="请输入轨道交通系统编码" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="轨道交通系统名称" prop="metroName">
              <el-input v-model="form.metroName" placeholder="请输入轨道交通系统名称" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="轨道系统logo" prop="metroLogo">
              <image-upload v-model="form.metroLogo" :limit="1" action="/admin/metro/sys/logo">
              </image-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form.remark" type="textarea" placeholder="请输入内容" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <metro-detail :visible.sync="drawerVisible" :row="drawerRow" />
  </div>
</template>

<script>
import MetroDetail from "./metro-detail.vue";
import { listMetro, getMetro, delMetro, addMetro, updateMetro } from "@/api/metro/sys"

export default {
  components: {
    MetroDetail
  },
  name: "MetroSys",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      // 轨道交通系统表格数据
      metroList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        metroCode: [
          { required: true, message: "轨道交通系统编码不能为空", trigger: "blur" }
        ],
        metroName: [
          { required: true, message: "轨道交通系统名称不能为空", trigger: "blur" }
        ],
      },
      // 线路数据抽屉状态
      drawerVisible: false,
      // 线路数据信息
      drawerRow: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    /** 查询轨道交通系统列表 */
    getList() {
      this.loading = true
      listMetro().then(response => {
        this.metroList = response.data
        this.total = response.data.length
        this.loading = false
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        metroId: null,
        metroCode: null,
        metroName: null,
        metroLogo: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null
      }
      this.resetForm("form")
    },
    handleToLine(row){
      this.$tab.openPage('轨道线路','/metro/metro-line',{ metroId:row.metroId});
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.title = "添加轨道交通系统"
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      const metroId = row.metroId
      getMetro(metroId).then(response => {
        this.form = response.data
        this.open = true
        this.title = "修改轨道交通系统"
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.metroId != null) {
            updateMetro(this.form).then(response => {
              this.$modal.msgSuccess("修改成功")
              this.open = false
              this.getList()
            })
          } else {
            addMetro(this.form).then(response => {
              this.$modal.msgSuccess("新增成功")
              this.open = false
              this.getList()
            })
          }
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      let metroId = row.metroId
      this.$modal.confirm('是否确认删除轨道交通系统名称为"' + row.metroName + '"的数据项？').then(function() {
        return delMetro(metroId)
      }).then(() => {
        this.getList()
        this.$modal.msgSuccess("删除成功")
      }).catch(() => {})
    },
    /** 线路数据抽屉显示信息 */
    handleViewData(row){
      this.drawerRow = row
      this.drawerVisible = true
    }
  }
}
</script>
